export const styles = theme => ({

	root: {
		// marginBottom: '4px',
		backgroundColor: '#FFFFFF',
		border: '1px solid #DDDDDD',
		borderRadius: '2px',
		boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.12)',
	},
});